import getConfig from 'next/config';

export default function Footer() {
  const { publicRuntimeConfig } = getConfig() as {
    publicRuntimeConfig: { version: string | undefined };
  };

  return (
    <footer className="p-3">
      <div className="flex w-full">
        <span className="mt-2 w-full text-sm font-light text-gray-500 md:ml-2.5 md:mt-0 text-center">
          WearHealth App v{publicRuntimeConfig?.version} |{' '}
          <a href="https://wearhealth.com/data-privacy/" target="_blank">
            Data Privacy
          </a>{' '}
          &#8226;{' '}
          <a href="https://wearhealth.com/legal-notice/" target="_blank">
            Legal Notice
          </a>
        </span>
      </div>
    </footer>
  );
}
